// extracted by mini-css-extract-plugin
export var checkboxInputRow = "z_tp";
export var checkboxInputColumn = "z_tq";
export var inputOptionRow = "z_r5";
export var inputOptionColumn = "z_r6";